import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';

import Market from './market';
import PlayersMarket from '../../mobile/components/markets/players-market';
import { LLTextSlider } from '../../../../components';
import { trans } from '../../../../common/utils';
import { DeleteFavoriteItemModal } from '../my-favorites/delete-fav-tournament-modal';

const SpecifierBasedMarkets = observer(
    ({
        item,
        match,
        userCanCashout,
        viewSize,
        isOldView,
        setOldView,
        oddAppearance,
        favorites,
        isMarketsTabView,
        user,
        withoutSpecifierBasedHeader,
        isFavorite,
        modal,
        j,
    }) => {
        const [opened, setOpened] = useState(!(item.viewOrder > 10));

        const isMultipleSpecifierMarket = !withoutSpecifierBasedHeader && item.market.specifierBasedMarkets?.length > 1;

        const marketsMarkUp = item.market.specifierBasedMarkets.map((market, i) => {
            return (
                <Market
                    key={j * 100 + i}
                    {...{
                        match,
                        market,
                        userCanCashout,
                        viewSize,
                        isOldView,
                        setOldView,
                        oddAppearance,
                        viewOrder: item.viewOrder,
                        withHeader: !isMarketsTabView,
                        userIsLogged: user.isLogged,
                        favorites,
                        favLoading: favorites.marketsLoading,
                        openedByDefault: isMultipleSpecifierMarket ? i === 0 : undefined,
                        isMultipleSpecifierMarket,
                        withFavorite: !isMarketsTabView && !isMultipleSpecifierMarket,
                        isFavorite,
                        modal,
                    }}
                />
            );
        });

        return (
            <>
                {isMultipleSpecifierMarket ? (
                    <div className="match-details__market match-details__multiple-market">
                        <div
                            className="match-details__market-header match-details__multiple-market-header"
                            onClick={() => {
                                setOpened((v) => !v);
                            }}
                        >
                            {user.isLogged ? (
                                <span className="match-details__market-header-clickers">
                                    <span
                                        className="match-details__market-header-fav-icon-wrp"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!favorites.marketsLoading) {
                                                if (isFavorite && favorites.isMarketFavorite({ id: item.market.id })) {
                                                    modal.setModal({
                                                        active: true,
                                                        maskBackground: true,
                                                        showHeader: true,
                                                        title: trans('Favorite markets'),
                                                        showCloseButton: true,
                                                        currentKey: 'custom-content',
                                                        customClasses: 'delete-favorite-modal',
                                                        customContent: (
                                                            <DeleteFavoriteItemModal
                                                                deleteItem={(e) => {
                                                                    e.preventDefault();
                                                                    favorites.setFavoriteMarket({
                                                                        id: item.market.id,
                                                                        isFavorite: true,
                                                                    });
                                                                    modal.close();
                                                                }}
                                                                type="market"
                                                            />
                                                        ),
                                                    });
                                                } else {
                                                    favorites.setFavoriteMarket({
                                                        id: item.market.id,
                                                    });
                                                }
                                            }
                                        }}
                                    >
                                        <i
                                            className={`match-details__market-header-fav-icon doruk-star-${
                                                favorites.isMarketFavorite({ id: +item.market.id }) ? 'fill' : 'line'
                                            }`}
                                        ></i>
                                    </span>
                                </span>
                            ) : (
                                <span></span>
                            )}
                            <span>{item.market.shortName || item.market.shortedName || item.market.name}</span>
                            <span className={cx('match-details__multiple-market-icon', opened && 'expanded')}>
                                <i className={cx(' llg-chevron-right')} />
                            </span>
                        </div>
                        <div className={cx('match-details__multiple-market-content', opened && 'expanded')}>
                            {marketsMarkUp}
                        </div>
                    </div>
                ) : null}
                {!isMultipleSpecifierMarket ? marketsMarkUp : null}
            </>
        );
    }
);

const Markets = ({
    match,
    marketGroup,
    activeMarketGroup,
    userCanCashout,
    oddAppearance,
    viewSize,
    marketsCount = 0,
    isOldView,
    setOldView,
    isMarketsTabView = false,
    isFavorite,
    user = {},
    favorites,
    withoutSpecifierBasedHeader,
    modal,
}) => {
    const [activeMarket, setActiveMarket] = useState(null);

    useEffect(() => {
        if (isMarketsTabView) {
            setActiveMarket(marketGroup.marketsList(marketsCount)[0]?.market.id);
        }
    }, [isMarketsTabView, marketGroup]);

    const renderMarket = (item, j = 0) => {
        if (item) {
            if (item.market.specifierBasedMarkets.length) {
                if (item.market.isNewPlayersMarket) {
                    return (
                        <PlayersMarket
                            key={j}
                            items={item.market.specifierBasedMarkets}
                            market={item.market}
                            viewSize={viewSize}
                            userCanCashout={userCanCashout}
                            withHeader={!isMarketsTabView}
                            viewOrder={item.viewOrder}
                            match={match}
                            activeMarketGroup={activeMarketGroup}
                            userIsLogged={user.isLogged}
                            favorites={favorites}
                            favLoading={favorites.marketsLoading}
                            isFavorite={isFavorite}
                            modal={modal}
                        />
                    );
                } else {
                    return (
                        <SpecifierBasedMarkets
                            {...{
                                item,
                                match,
                                userCanCashout,
                                viewSize,
                                isOldView,
                                setOldView,
                                oddAppearance,
                                favorites,
                                isMarketsTabView,
                                user,
                                withoutSpecifierBasedHeader,
                                isFavorite,
                                modal,
                                j,
                            }}
                            key={j}
                        />
                    );
                }
            } else {
                return (
                    <Market
                        key={j}
                        {...{
                            match,
                            market: item.market,
                            userCanCashout,
                            viewSize,
                            isOldView,
                            setOldView,
                            oddAppearance,
                            viewOrder: item.viewOrder,
                            withHeader: !isMarketsTabView,
                            userIsLogged: user.isLogged,
                            favorites,
                            favLoading: favorites.marketsLoading,
                            withFavorite: true,
                            isFavorite,
                            modal,
                        }}
                    />
                );
            }
        } else {
            return null;
        }
    };

    const renderTabsMarkets = (marketsArr) => {
        return (
            <LLTextSlider
                id={`market-tabs__slider`}
                viewSize={viewSize}
                customClasses={{
                    slider: 'market-tab__slider',
                    arrow: 'market-tab__slider-arrow',
                }}
                activeItem={activeMarket}
                withAbsoluteArrows={true}
                showArrows={false}
            >
                {marketsArr.map((item) => {
                    return (
                        <div
                            className={cx('market-tab__slider-item', activeMarket === item.market.id && 'active')}
                            onClick={() => {
                                setActiveMarket(item.market.id);
                            }}
                            id={item.market.id}
                            key={item.market.id}
                        >
                            {user.isLogged ? (
                                <span
                                    className="match-details__market-header-fav-icon-wrp"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (!favorites.marketsLoading) {
                                            favorites.setFavoriteMarket({
                                                id: item.market.id,
                                            });
                                        }
                                    }}
                                >
                                    <i
                                        className={`match-details__market-header-fav-icon doruk-star-${
                                            favorites.isMarketFavorite({ id: +item.market.id }) ? 'fill' : 'line'
                                        }`}
                                    ></i>
                                </span>
                            ) : null}
                            <span>{item.market.shortName || item.market.shortedName || item.market.name}</span>
                        </div>
                    );
                })}
            </LLTextSlider>
        );
    };

    if (!marketGroup) {
        return null;
    }

    const renderMarkets = (marketsArr) =>
        marketsArr.length ? marketsArr.map((item, j) => renderMarket(item, j)) : null;

    const marketList = isFavorite ? marketGroup.markets : marketGroup.marketsList(marketsCount);

    return isMarketsTabView ? (
        <>
            {renderTabsMarkets(marketList)}
            {renderMarket(marketList.find((item) => item.market.id === activeMarket))}
        </>
    ) : (
        renderMarkets(marketList)
    );
};

export default observer(Markets);
